import GetQuoteForm from "components/common/GetQuoteForm";
import GetQuoteForm1 from "components/common/GetQuoteForm1";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function ShaerdSafariTourTabSekelton({ count }) {
  return (
    <>
      <section className="touroprator_section margin_bottomfooter">
        <Container fluid id="viewcontent">
          <Row className="justify-content-center">
            <Col xxl={8} xl={10} lg={12}>
              <Row className="pt-2 pb-4">
                <Col lg={12} md={12} xxl={12} xl={12}>
                  <Row>
                    <Col xxl={8} lg={8} className="mb-4">
                      <div className="card card_bodyPadding">
                        <div className="card-body">
                          <div className="tab-content_tour active">
                            <div className="d-flex justify-content-between flex-wrap">
                              <h6 className="fs-6 fw-bold mb-0 p-0">
                                <Skeleton width={300} height={20} />
                              </h6>
                              <Skeleton width={80} height={20} />
                            </div>

                            <Row className="gx-md-3 mt-3">
                              {[...Array(count)].map((_, index) => (
                                <Col
                                  md={6}
                                  sm={6}
                                  lg={6}
                                  xxl={6}
                                  className="mb-4"
                                  key={index}
                                >
                                  <div className="shareimg">
                                    <Skeleton height={178} />
                                  </div>
                                  <div
                                    className="sharesafri-card sharesafri-card-dummy"
                                    key={index}
                                  >
                                    <div className="pt-2">
                                      <div className="safari d-flex justify-content-between px-2">
                                        <div className="safarinum d-flex gap-2 align-items-center">
                                          <Skeleton height={20} width={50} />
                                          <Skeleton height={20} width={30} />
                                        </div>
                                        <div className="safarinum d-flex gap-2 align-items-center">
                                          <Skeleton height={20} width={50} />
                                          <Skeleton height={20} width={30} />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="titleDate">
                                      <Skeleton height={20} width={`80%`} />
                                      <Skeleton
                                        height={16}
                                        width={`60%`}
                                        className="mt-1"
                                      />
                                    </div>

                                    <div className="footer_card row pb-2 px-2 align-items-center">
                                      <div className="col-6">
                                        <Skeleton
                                          height={25}
                                          width={25}
                                          circle
                                          containerClassName="users"
                                        />
                                      </div>
                                      <div className="col-6 text-center">
                                        <Skeleton
                                          height={30}
                                          width={100}
                                          borderRadius={8}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Col>
                     <Col xxl={4} lg={4} className="=ps-md-4">
                      <GetQuoteForm1 />
                      {/* <OperatorRating /> */}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default ShaerdSafariTourTabSekelton;
